// extracted by mini-css-extract-plugin
export default {"section":"Advertise_section__WREf9","wrapper":"Advertise_wrapper__zEgzm"};